import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { BrochureProps } from './brochure.props'
import { Heading } from '../Common'
import { Config } from '../../config'

const PDF = dynamic(() => import('./Components/PDF'), {
  ssr: false,
})

export const Brochure = ({
  pdf,
  title,
  pageHeight,
  pageWidth,
  errorMessage,
}: BrochureProps) => {
  const [renderBrochure, setRenderBrochure] = useState(false)

  // The package does not support ssr
  useEffect(() => {
    setRenderBrochure(true)
  }, [])

  return (
    <Container>
      <Heading data={title} topTitle />
      <div className="d-flex align-items-center justify-content-center">
        <PDFWrapper style={{ minHeight: pageHeight, width: pageWidth }}>
          {renderBrochure && (
            <PDF
              pdf={pdf}
              width={pageWidth}
              height={pageHeight}
              errorMessage={errorMessage}
            />
          )}
        </PDFWrapper>
      </div>
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'container ',
})``

const PDFWrapper = styled.div.attrs({
  className: 'd-flex mt-4',
})`
  max-width: 100%;

  background: ${({ theme }) => theme.palette.disabled};
`
